'use strict';
var $ = require('../internals/export');

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  EPSILON: Math.pow(2, -52)
});



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/modules/es.number.epsilon.js
// module id = 1027
// module chunks = 0